import { CoreStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { observable, action, runInAction, computed, toJS, makeObservable } from "mobx";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { API } from "General/API";

export class EmailInboxFilterStore extends CoreStore {
  data: API_MailInboxFilter[] = [];
  conventions: string[] = [];
  actionState: StoreState = "RAW";

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      conventions: observable,
      actionState: observable,
      clear: action,
      list: computed,
      fetch: action.bound,
    });
  }

  clear() {
    this.data = [];
    this.conventions = [];
    this.actionState = "RAW";
  }

  url(filterId?: number) {
    if (filterId) {
      return API_URL.PROJECT_INBOXES.getMailFilter(projectsDataStore.projectId, filterId);
    }
    return API_URL.PROJECT_INBOXES.getMailFilters(projectsDataStore.projectId);
  }

  @handleStoreState()
  async fetch() {
    try {
      const response = await API.getData<API_MailInboxFilter[]>(this.url());
      const conventions = await API.getData(
        API_URL.PROJECT_INBOXES.getFilenameConventionsForInboxes(projectsDataStore.projectId)
      );
      runInAction(() => {
        this.data = response;
        this.conventions = conventions;
      });
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState<EmailInboxFilterStore>("actionState")
  async deleteItem(filterId: number) {
    try {
      await API.deleteData(this.url(filterId));
      this.fetch();
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState<EmailInboxFilterStore>("actionState")
  async editItem(filterId: number, values: API_MailInboxFilter) {
    try {
      await API.editData(this.url(filterId), values);
      this.fetch();
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState<EmailInboxFilterStore>("actionState")
  async createItem(values: API_MailInboxFilter) {
    try {
      await API.newData(this.url(), values);
      this.fetch();
    } catch (error) {
      throw error;
    }
  }

  getItem(filterId: number) {
    return this.data.find((item) => item.id === filterId);
  }

  get list() {
    return toJS(this.data);
  }
}

export const emailInboxFilterStore = new EmailInboxFilterStore();
